import React from 'react';

interface SessionExpiredModalProps {
    isOpen: boolean;           // 모달 표시 여부
    onConfirm: () => void;     // "로그인하기" 버튼 클릭 핸들러
    // onCancel?: () => void;     // "닫기" 버튼 클릭 핸들러 (선택사항)
    message?: string;          // 표시할 메시지 (기본값: '세션이 만료되었습니다. 다시 로그인해주세요.')
}

export const SessionExpiredModal: React.FC<SessionExpiredModalProps> = ({
    isOpen,
    onConfirm,
    // onCancel,
    message = '세션이 만료되었습니다. 다시 로그인해주세요.'
}) => {
    // 모달이 열리지 않았으면 렌더링하지 않음
    if (!isOpen) return null;

    return (
        // 전체 화면을 덮는 반투명 배경
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            {/* 모달 컨테이너 */}
            <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl">
                <div className="text-center">
                    {/* 경고 아이콘 */}
                    <div className="text-red-500 text-6xl mb-4">⚠️</div>
                    
                    {/* 모달 제목 */}
                    <h2 className="text-xl font-bold text-gray-800 mb-4">
                        세션 만료
                    </h2>
                    
                    {/* 사용자 정의 메시지 */}
                    <p className="text-gray-600 mb-6 leading-relaxed">
                        {message}
                    </p>
                    
                    {/* 버튼 영역 */}
                    <div className="flex gap-3 justify-center">
                        {/* 로그인하기 버튼 */}
                        <button
                            onClick={onConfirm}
                            className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors duration-200 font-medium"
                        >
                            로그인하기
                        </button>
                        
                        {/* 닫기 버튼 (onCancel이 있을 때만 표시) */}
                        {/* {onCancel && (
                            <button
                                onClick={onCancel}
                                className="px-6 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 transition-colors duration-200 font-medium"
                            >
                                닫기
                            </button>
                        )} */}
                    </div>
                </div>
            </div>
        </div>
    );
};
